// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"929c5fe3","453":"aeec4575","455":"abc76648"}[chunkId] + ".chunk.js";
};